import SettingsIcon from '@atlaskit/icon/core/settings';
import * as React from 'react';

export function SvgSettings() {
  return <SettingsIcon label="" testId="ads-refreshed-icon" />;
}
